module.exports = __webpack_public_path__ + "img/skip.03cef9a5.svg";